import React from 'react';
import { Auth } from 'aws-amplify';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import InfoIcon from '@material-ui/icons/Info';
import Divider from '@material-ui/core/Divider';
import Form from 'components/form';
import Input from 'components/form/Input';
import Button from 'components/common/Button';
import useSnack  from 'hooks/useSnack';
import useStyles from '../styles';

const FormItem = Form.FormItem;

const ChangePasswordForm = ({
  form: { getFieldDecorator, validateFields, getFieldValue, setFieldsValue },
}) => {
  const snack = useSnack();
  const classes = useStyles();

  const onSubmit = () => {
    return validateFields().then((values) => {
      return Auth.currentAuthenticatedUser()
        .then((user) => {
          return Auth.changePassword(
            user,
            values.currentPassword,
            values.newPassword,
          );
        })
        .then((data) => {
          setFieldsValue({
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          });
          snack.success('Password successfully changed.');
        })
        .catch((err) => snack.error(err.message));
    });
  };

  const validatePassword = async (filed, value) => {
    const newPassword = getFieldValue('newPassword');
    if (newPassword !== value) {
      throw new Error('Password do not match');
    }
  };

  return (
    <Card>
      <CardContent className={classes.cardContent}>
        <Grid container spacing={4}>
          <Grid item md={8}>
            <Typography variant="h5" className={classes.header}>
              Change password
            </Typography>
            <Form>
              <FormItem>
                {getFieldDecorator('currentPassword', {
                  rules: [
                    { required: true, message: 'Enter current password' },
                  ],
                })(
                  <Input fullWidth label="Current Password" type="password" />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('newPassword', {
                  rules: [{ required: true, message: 'Enter new password' }],
                })(<Input fullWidth label="New password" type="password" />)}
              </FormItem>
              <FormItem>
                {getFieldDecorator('confirmPassword', {
                  rules: [
                    { required: true, message: 'Confirm password' },
                    { validator: validatePassword },
                  ],
                })(
                  <Input
                    fullWidth
                    label="Repeat new password"
                    type="password"
                  />,
                )}
              </FormItem>
            </Form>
          </Grid>
          <Grid
            item
            md={4}
            style={{ alignSelf: 'flex-end', marginBottom: '8%' }}
          >
            <Card>
              <CardContent>
                <InfoIcon color="primary" fontSize="large" />
                <Typography variant="body2">
                  Create your password using 8 characters or more. It can be any
                  combination of letters, numbers, and symbols (ASCII-standard
                  characters only). Accents and accented characters aren't
                  supported.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent className={classes.footer}>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          Save
        </Button>
      </CardContent>
    </Card>
  );
};

export default Form.create()(ChangePasswordForm);
